import React, { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import * as styles from './modal.module.css'
import { CSSTransition } from 'react-transition-group'

const Modal = (props) => {
  const [canRender, setCanRender] = useState(false)
  useEffect(() => setCanRender(true))

  return (
    <React.Fragment>
      {canRender
        ? ReactDOM.createPortal(
            <CSSTransition
              in={props.show}
              unmountOnExit
              timeout={{ enter: 0, exit: 300 }}
              classNames={{
                enterDone: styles.enterDone,
                exit: styles.exit,
              }}
            >
              <div
                className={styles.modal}
                onClick={props.onClose}
                role="presentation"
              >
                <div
                  className={styles.modalContent}
                  onClick={(e) => e.stopPropagation()}
                  role="presentation"
                >
                  <header className={styles.modalHeader}>
                    <h4>Нужен сайт?</h4>
                    <span>
                      Заполните форму и мы свяжемся с Вами в кротчайшие сроки.
                      Поможем выбрать подходящий тариф, обсудим детали и начнем
                      создание Вашего сайта.
                    </span>
                  </header>
                  <div className={styles.modalBody}>
                    <form
                      name="Order Form"
                      method="POST"
                      data-netlify="true"
                      action="/thank-you"
                      className={styles.modalForm}
                    >
                      <input
                        type="hidden"
                        name="form-name"
                        value="Order Form"
                      />

                      <input
                        type="text"
                        required
                        placeholder="Ваше имя"
                        name="name"
                      ></input>
                      <input
                        type="number"
                        required
                        autoComplete="something-unsupported"
                        placeholder="Номер телефона"
                        name="phone"
                      ></input>
                      <input
                        type="email"
                        placeholder="Ваш Email"
                        name="email"
                      ></input>
                      <input
                        type="text"
                        placeholder="Название Вашего бизнеса или проекта"
                        name="business name"
                      ></input>
                      <button>Сделать заказ</button>
                    </form>
                  </div>
                  <footer className={styles.modalFooter}>
                    <button
                      onClick={props.onClose}
                      className={styles.modalButton}
                    >
                      &#215;
                    </button>
                    <span>
                      Нажимая на кнопку, Вы соглашаетесь с обработкой
                      персональных данных
                    </span>
                  </footer>
                </div>
              </div>
            </CSSTransition>,
            document.getElementById('___gatsby')
          )
        : ''}
    </React.Fragment>
  )
}

export default Modal
